interface StatCardProps {
  icon: string;
  value: string | number;
  subtitle: string;
  color: 'emerald' | 'blue' | 'purple' | 'orange' | 'red' | 'yellow';
  onClick?: () => void;
}

export default function StatCard({ icon, value, subtitle, color, onClick }: StatCardProps) {
  const colorClasses = {
    emerald: 'bg-emerald-50 border-emerald-200 text-emerald-600',
    blue: 'bg-blue-50 border-blue-200 text-blue-600',
    purple: 'bg-purple-50 border-purple-200 text-purple-600',
    orange: 'bg-orange-50 border-orange-200 text-orange-600',
    red: 'bg-red-50 border-red-200 text-red-600',
    yellow: 'bg-yellow-50 border-yellow-200 text-yellow-600'
  };
  
  const iconBgClasses = {
    emerald: 'bg-emerald-500',
    blue: 'bg-blue-500',
    purple: 'bg-purple-500',
    orange: 'bg-orange-500',
    red: 'bg-red-500',
    yellow: 'bg-yellow-500'
  };
  
  return (
    <div 
      className={`text-center p-4 rounded-2xl border ${colorClasses[color]} ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
      onClick={onClick}
    >
      <div className={`w-12 h-12 ${iconBgClasses[color]} rounded-2xl flex items-center justify-center mb-2 mx-auto`}>
        <i className={`${icon} text-white text-xl`}></i>
      </div>
      <p className="text-2xl font-bold font-sans" style={{ fontWeight: 700 }}>{value}</p>
      <p className="text-xs mt-1 font-sans" style={{ fontWeight: 500 }}>{subtitle}</p>
    </div>
  );
}
